import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiAuth } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private http: HttpClient,
  ) { }

  get(ruta: string): Observable<any> {
    const headers = new HttpHeaders({ 'x-access-token': sessionStorage.getItem('token') });
    return this.http.get<any>(apiAuth + ruta, { headers });
  }

  post(ruta: string, body): Observable<any> {
    const headers = new HttpHeaders({ 'x-access-token': sessionStorage.getItem('token') });
    return this.http.post<any>(apiAuth + ruta, body, { headers });
  }

  put(ruta: string, body): Observable<any> {
    const headers = new HttpHeaders({ 'x-access-token': sessionStorage.getItem('token') });
    return this.http.put<any>(apiAuth + ruta, body, { headers });
  }

  del(ruta: string): Observable<any> {
    const headers = new HttpHeaders({ 'x-access-token': sessionStorage.getItem('token') });
    return this.http.delete<any>(apiAuth + ruta, { headers });
  }

}
